import React, { useRef } from 'react'
import _ from "lodash"
import moment from "moment"
import { Row, Col, Button } from "reactstrap"
import { useTranslation } from 'react-i18next'
import { useReactToPrint } from "react-to-print";

import i18n from 'utils/translation/i18n'
import Modal from "main_views/components/Modal"
import Form from 'main_views/components/Form/form_v2'
import Print from 'main_views/components/print'

function MessageModal(props) {

    let { t } = useTranslation()

    let { isOpen, toggle, ticket } = props
    let title = ('#' + ticket?.number) ?? ''
    let subTitle = ticket?.form?.name ?? ''

    let printRef = useRef()

    let print = useReactToPrint({
        content: () => printRef.current,
        debug: true
    })

    if (_.isEmpty(ticket)) return <></>

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            title={title}
            subTitle={subTitle}
            removeBodyPaddings={true}
            hasFooter={true}
            saveText={t('print')}
            onSave={print}
            hideCancelBtn={true}
        >

            <div style={{ minHeight: '50vh', display: 'grid' }} className='p-3' >

                <div ref={printRef}>

                    <Print {...props}/>

                </div>

            </div>

        </Modal>
    )
}

export default MessageModal